export default "__VITE_ASSET__eR6bgNRS__"